/*========================================================================
* $Id$
*
* Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
*
* Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
* Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
* Urheber festgelegten Stelle in der Funktion des Computerprogramms
* angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
* Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
* Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
* =========================================================================*/

/*
* BreadcrumbTemplate
* ==================
*
* A component to display a breadcrumb of constraints.
*
*/

define(
  [
    "component!base",
    "client/template",
    "client/views/list",
    "component!filteredfacet",
		"i18n/i18n",
    "underscore",
    "backbone",
    "!!raw-loader!../mustache/template.mustache"
  ],
  function (
    Base,
    Template,
    ListView,
    FilteredFacetTemplate,
		i18n,
    _,
    Backbone,
    DEFAULT_TEMPLATE
  ) {

  var BreadcrumbTemplate = Template.extend({

      schema: new Template.Schema({
        attributes: {
          displayFilteredfacets: {
            type: "boolean",
            defaultValue: false
          }
        }
      }),

    hasContent: function() { return true; },
    getContentSchema: function() {
      return  {
        type: "template"
      };
    },

    createView: function (options) {
      options = _.extend(
        {},
        this.schema ? this.schema.parseAttributes(this.attributeModel.getCamelCase()): this.attributeModel.getCamelCase(),
        options
      );
      options.childTemplates = _.pluck(options.node && options.node.children, "template");
      options.facetsModel = Template.prototype.model.call(this, options).output.submodel("facets");
      if (options.node) delete options.node.children;

      return Template.prototype.createView.call(this, options);
    },

    model: function () {
      var model = Template.prototype.model.apply(this, arguments);
      return model.input.submodel("user");
    }

  });

  var MustacheTemplateListView = ListView.extend({

    createEntryView: function (options) {
      return this.options.elementTemplate.createView(_.extend({
        application: this.options.application,
        tagName: this.options.entryTagName,
        className: this.options.entryClassName,
        role: this.options.entryRole,
        referenceList: this.children
      },
      options
      )).render();
    }

  });

  var BreadcrumbModel = Backbone.Model.extend({});
  var BreadcrumbCollection = Backbone.Collection.extend({
    model: BreadcrumbModel
  });

  BreadcrumbTemplate.Model = BreadcrumbModel;
  BreadcrumbTemplate.Collection = BreadcrumbCollection;

  BreadcrumbTemplate.View = Base.extend({
    // TODO: cleanup

    initialize: function () {
      this.selectedFilters = new BreadcrumbCollection();

      this.listenTo(this.model, "change", this.inputChanged);
      if (this.options.facetsModel) {
        this.listenTo(this.options.facetsModel, "change", this.outputChanged);
      }
      this.listenTo(this.selectedFilters, "destroy", this.modelDestroyed);

      this.listView = new MustacheTemplateListView({
        className: "inline",
        application: this.options.application,
        model: this.selectedFilters,
        elementTemplate: this.options.childTemplates[0]
      });
      this.appendChild(this.listView.el);
    },

    inputChanged: function () {
      var selectedFilters = this.getSelectedFilters();
      
    },

    outputChanged: function () {
      var facetsModel = this.options.facetsModel;
      _.each(this.selectedFilters.models,function(m) { 
        var id = m.attributes.filterID.replace(/filter_/,'')
        _.each(facetsModel.attributes,function(f) {
          if(id === f.id) {
            var k = m.attributes.key;
            _.each(f.entries, function(e) {
              if(e.id === k) {
                var attr = _.extend({},m.attributes);
                attr.html = e.html;
                m.set(attr);
              }
            });
          }
        });
      });
    },

    modelDestroyed: function (model) {
      try {
        if (model.get("type") === "filter") {
          this.removeFilterSelection(model);
        } else {
          this.removeQuery(model);
        }
      } catch (e) {
        if (typeof console !== "undefined") console.error(e);
      }
    },

    removeQuery: function (model) {
      var submodel = this.model.submodel(model.id);
      submodel.unset();
      submodel.dispose();
    },

    removeFilterSelection: function (model) {
      var constraintsModel = this.model.submodel("constraints");
      var queryExpr = this.model.get(model.get("path"));
      var key = model.get("key");
      var filterBase = _.extend({}, queryExpr.filter_base);
      var entry = filterBase[key];
      delete filterBase[key];
      var filtered = _.extend({}, queryExpr.filtered);
      filtered[key] = entry;

      FilteredFacetTemplate.View.prototype._setConstraint.apply({
          options: {
            facetName: queryExpr.label,
            intersectValues: queryExpr.filter_join === "AND"
          },
          originalFacetTitle: queryExpr.filtered_name,
          constraintsModel: constraintsModel,
          filterID: model.get("filterID")
        }, [
          filtered,
          filterBase
      ]);

      constraintsModel.dispose();
    },

    getSelectedFilters: function () {
      var application = this.options.application;
      var toDelete = _.pluck(this.selectedFilters.models, "id");
      var added = [];
      var selectedFilters = this.selectedFilters;
      var displayFilteredfacets = this.options.displayFilteredfacets;

      _.each(this.model.get("constraints"), function (filter, name) {
        if (filter.filter_base && filter.filtered_name) {
          // filteredfacets
          if (displayFilteredfacets) {
            _.each(filter.filter_base, function (queryExpr, key) {
              var path = "['" + name + "']";
              var id = path + ".filter_base['" + key + "']";
              selectedFilters.add({
                description: i18n(filter.filtered_name) + ": " + (queryExpr.description || queryExpr.id),
                filterName: filter.filtered_name,
                html: (queryExpr.description || queryExpr.id),
                id: id,
                path: path,
                key: key,
                type: "filter",
                filterID: name
              }, { merge: true });
              added.push(id);
            });
          }
        } else if (filter.description) {
          // query & subquery actions or other constraints having a description
          var id = application.sanitizePath(name);
          selectedFilters.add({ description: filter.description, id: id, filterID: name}, { merge: true });
          added.push(id);
        }
      });
      selectedFilters.remove(_.difference(toDelete, added));

      return selectedFilters;
    }

  });

  BreadcrumbTemplate.DEFAULT_TEMPLATE = DEFAULT_TEMPLATE && DEFAULT_TEMPLATE.default;

  return BreadcrumbTemplate;
});
